<!-- Topbar Start -->
<div class="navbar navbar-expand flex-column flex-md-row navbar-custom">
  <div class="container-fluid">
    <!-- LOGO -->
    <!-- <a routerLink="/" class="navbar-brand mr-0 mr-md-2 logo">
      <span class="logo-lg">
        <img src="" alt="" height="24" />
        <span class="d-inline h5 ml-1 text-logo ml-2">logo name</span>
      </span>
      <span class="logo-sm">
        <img src="" alt="" height="24">
      </span>
    </a> -->

    <ul
      class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0 align-items-center"
    >
      <li class="">
        <button
          class="button-menu-mobile open-left disable-btn"
          (click)="toggleMobileMenu($event)"
        >
          <i [attr.data-feather]="'menu'" class="menu-icon" appFeatherIcon></i>
          <i [attr.data-feather]="'x'" class="close-icon" appFeatherIcon></i>
        </button>
      </li>
      <ng-template [featureFlag]="'dashboards'">
        <li class="d-md-block d-none">
          <a href="javascript:void(0)" class="nav-link"> Dashboards </a>
        </li>
      </ng-template>
      <li class="d-md-block d-none">
        <a
          href="javascript:void(0)"
          class="nav-link"
          routerLink="/project"
          routerLinkActive="active"
        >
          Projects
        </a>
      </li>
      <ng-template [featureFlag]="'tasks'">
        <li class="d-md-block d-none">
          <a href="javascript:void(0)" class="nav-link"> Tasks </a>
        </li>
      </ng-template>
      <li class="d-md-block d-none">
        <a
          href="javascript:void(0)"
          class="nav-link"
          routerLink="/setup"
          routerLinkActive="active"
        >
          Setup
        </a>
      </li>
    </ul>

    <ul
      class="navbar-nav flex-row ml-auto d-flex list-unstyled topnav-menu float-right mb-0"
    >
      <li
        class=""
        [routerLink]="[{ outlets: { dialog: ['dialog', 'project'] } }]"
      >
        <a href="javascript:void(0);" class="global-add-button">
          <span>+</span>
        </a>
      </li>
      <li class="d-none d-sm-block">
        <ng-template [featureFlag]="'globalSearch'">
          <div class="app-search">
            <form>
              <div class="input-group">
                <input type="text" class="form-control" placeholder="Search" />
                <i [attr.data-feather]="'search'" appFeatherIcon></i>
              </div>
            </form>
          </div>
        </ng-template>
      </li>
      <li
        class="dropdown notification-list align-self-center profile-dropdown"
        ngbDropdown
      >
        <a
          class="dropdown-toggle nav-user mr-0"
          ngbDropdownToggle
          href="javascript:void(0);"
          role="button"
        >
          <div class="media">
            <fa-icon [icon]="userIcon" class="user-profile">
            </fa-icon>
          </div>
        </a>
        <div
          class="dropdown-menu profile-dropdown-items dropdown-menu-right"
          ngbDropdownMenu
        >
          <span *ngIf="currentUser?.firstName || currentUser?.lastName"
            >{{ currentUser.firstName }}&nbsp;{{ currentUser.lastName }}</span
          >
          <a
            routerLink="/setup/profile-settings"
            class="dropdown-item notify-item"
            ngbDropdownItem
          >
            <fa-icon [icon]="userIcon" class="icon"></fa-icon>
            <span>&nbsp;Profile</span>
          </a>
          <a
            href="javascript:void(0);"
            class="dropdown-item notify-item"
            [routerLink]="'/setup'"
            ngbDropdownItem
          >
            <fa-icon [icon]="settingsIcon" class="icon"></fa-icon>
            <span>&nbsp;Setup</span>
          </a>
          <div class="dropdown-divider"></div>

          <a
            href="javascript:void(0);"
            (click)="logout()"
            class="dropdown-item notify-item"
            ngbDropdownItem
          >
            <fa-icon [icon]="signoutIcon" class="icon"></fa-icon>
            <span>&nbsp;Logout</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</div>
<!-- end Topbar -->
